import { Maybe } from 'types/UtilityTypes';
import { QuotingPortals } from 'types/enums/Integrations';

/**
 * When sidebar async submit-bid is polling (HTTP 202 from backend result
 * endpoint), show this reassurance below the submit button for the given
 * bidding portal integration name (same string as credential options /
 * `QuotingPortals`, e.g. `carrierpoint`).
 */
export const SUBMIT_BID_PORTAL_ASYNC_POLL_NOTICES: Partial<
  Record<string, string>
> = {
  [QuotingPortals.CarrierPoint]:
    "Bid submission in progress, we'll send you an email if it fails.",
};

export function getSubmitBidPortalAsyncPollNotice(
  integrationName: Maybe<string>
): Maybe<string> {
  const key = integrationName?.trim();
  if (!key) {
    return null;
  }
  return SUBMIT_BID_PORTAL_ASYNC_POLL_NOTICES[key] ?? null;
}
